<template>
  <v-data-table
    id="micro-duct-panel"
    :headers="headers"
    :items="ductConfigurationData.microducts ? ductConfigurationData.microducts : ductConfigurationData.cables"
    :page.sync="pagination.page"
    :items-per-page.sync="paginationMicroDuctPanel.rowsPerPage"
    :items-per-page-text="rowsPerPageText"
    :items-per-page-items="rowsPerPageItems"
    :header-props="{ sortIcon }"
    :footer-props="{ prevIcon, nextIcon, 'items-per-page-options': rowsPerPageItems }"
    hide-default-footer
    class="elevation-2"
    @pagination="setRowsOnLocalStorage(dataTableMicroDuctPanelId,paginationMicroDuctPanel.rowsPerPage)"
  >
    <template v-slot:item="props">
      <tr class="cursor-pointer">
        <td :style="{ padding: props.item.md_color_primary === props.item.md_color_secondary ? '0 0 0 7px' : '0 0 0 9px' }">
          <div
            class="microduct-color"
            :style="{
              'background-color': props.item.md_color_primary === props.item.md_color_secondary ? props.item.md_color_primary : '#ffffff',
              'box-shadow': props.item.md_color_primary !== props.item.md_color_secondary ? '0 0 0 3px ' + props.item.md_color_secondary : 'none',
              'outline': props.item.md_color_primary !== props.item.md_color_secondary ? 'dotted 4px ' + props.item.md_color_primary : 'none',
              'height': props.item.md_color_primary !== props.item.md_color_secondary ? '12px' : '16px',
              'width': props.item.md_color_primary !== props.item.md_color_secondary ? '12px' : '16px',
              'border-radius': props.item.md_color_primary !== props.item.md_color_secondary ? '6px' : '8px'
            }"
          />
        </td>

        <td>{{ props.item.md_label ? props.item.md_label : '-' }}</td>

        <td>{{ props.item.md_index ? props.item.md_index : props.index }}</td>

        <!-- <td>
          {{
            props.item.md_color_primary !== props.item.md_color_secondary ?
            props.item.md_color_primary + '-' + props.item.md_color_secondary :
            props.item.md_color_primary
          }}
        </td> -->

        <td>{{ props.item.cables ? props.item.cables[0].cb_label : props.item.cb_label }}</td>

        <td>{{
            ductConfigurationData.microducts ?
              props.item.cables ?
              cablesList.find(cable => cable.sm_id === props.item.cables[0].cb_material_id).sm_reference :
              '-' :
            cablesList.find(cable => cable.sm_id === props.item.cb_material_id).sm_description
        }}</td>

        <!-- <td>{{ props.item.owner }}</td>

        <td>{{ props.item.origin }}</td>

        <td>{{ props.item.destination }}</td> -->
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";

export default {
  name: "MicroDuctPanelContent",

  mixins: [managementDatatableMixin],

  props: {
    ductConfigurationData: {
      type: Object,
      required: false
    },

    cablesList: {
      type: Array
    }
  },

  data() {
    return {
      pagination: {
        sortBy: "index",
        descending: false,
        page: 1,
        rowsPerPage: -1
      },
      dataTableMicroDuctPanelId: "dataTableMicroDuctPanelId" ,
      paginationMicroDuctPanel: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableMicroDuctPanelId")
      },

    }
  },

  computed: {
    headers() {
      return [
        {
          text: '',
          align: "left",
          value: "state",
          width: "3%",
          sortable: false
        },
        {
          text: this.$i18n.tc("Tube", 1),
          align: "left",
          value: "tube",
          width: "25%",
          sortable: false
        },
        {
          text: this.$i18n.tc("Number", 1),
          align: "left",
          value: "index",
          width: "8%",
          sortable: false
        },
        // {
        //   text: this.$i18n.tc("Color", 1),
        //   align: "left",
        //   value: "color",
        //   width: "10%",
        //   sortable: false
        // },
        {
          text: this.$i18n.tc("Cable", 1),
          align: "left",
          value: "cable",
          sortable: false
        },
        {
          text: this.$i18n.tc("Material", 1),
          align: "left",
          value: "material",
          sortable: false
        },
        // {
        //   text: this.$i18n.tc("Owner", 1),
        //   align: "left",
        //   value: "owner",
        //   sortable: false
        // },
        // {
        //   text: this.$i18n.tc("Origin", 1),
        //   align: "left",
        //   value: "origin",
        //   sortable: false
        // },
        // {
        //   text: this.$i18n.tc("Destination", 1),
        //   align: "left",
        //   value: "destination",
        //   sortable: false
        // },
      ]
    },
  },
}
</script>

<style scoped>
.microduct-color {
  height: 16px;
  width: 16px;
  border-radius: 8px;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Pathways/MicroDuctPanelContent.vue